import "./popUp.css";

function PopUp({ show, dispatch }) {
  function clear() {
    // setItemsList([]);
    // setShow(false);
    dispatch({ type: "items", payload: [] });
    dispatch({ type: "show", payload: false });
  }

  function notclear() {
    // setShow(false);
    dispatch({ type: "show", payload: false });
  }

  return show ? (
    <div className="popUp">
      <div>
        <p>Are you sure you want delete it all</p>
        <div className="btns">
          <button onClick={clear}>✔️</button>
          <button onClick={notclear}>❌</button>
        </div>
      </div>
    </div>
  ) : null;
}

export default PopUp;
